<mat-toolbar class="header">
  <div class="header-brand">
    <a routerLink="/" class="header-logo-link" aria-label="Home">
      <img
        ngSrc="biologic-logo.png"
        width="164"
        height="48"
        priority
        alt="BioLogic"
        class="header-logo"
      />
      <span class="header-text header-app-name">Licensing Tool</span>
    </a>
  </div>

  <a
    routerLink="/customers"
    routerLinkActive="header-nav-link--active"
    [routerLinkActiveOptions]="{ exact: true }"
    class="header-nav-link"
  >
    <mat-icon>group</mat-icon>
    <span>Customers</span>
  </a>

  <a
    routerLink="/license-series"
    routerLinkActive="header-nav-link--active"
    [routerLinkActiveOptions]="{ exact: true }"
    class="header-nav-link"
  >
    <mat-icon>layers</mat-icon>
    <span>License series</span>
  </a>

  <div class="header-middle">
    @if (environmentLabel) {
      <div class="header-env-banner" role="status">
        <span class="header-env-banner-label">{{ environmentLabel }}</span>
      </div>
    }
  </div>

  <span class="header-text">{{ authState.displayName() }}</span>
  <button type="button" mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="User menu">
    <mat-icon>account_circle</mat-icon>
  </button>

  <mat-menu #userMenu="matMenu">
    @if (administrationEnabled()) {
      <a *appHasRole="'admin'" mat-menu-item routerLink="/admin">
        <mat-icon>admin_panel_settings</mat-icon>
        <span>Administration</span>
      </a>
    }
    <button type="button" mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Log out</span>
    </button>
  </mat-menu>
</mat-toolbar>
